/**
 * =============================================================================
 * IMPORTANT, READ THIS MESSAGE BEFORE EDITING THIS FILE.
 *
 * This file needs to be kept tightly in sync with its corresponding version in
 * the backend. If you are changing this file, please also make the
 * corresponding changes in `functions/src/assignments/userAssignmentMap.ts` and
 * submit both sides simultaneously.
 *
 * Be careful because import paths may be different and the APIs for
 * `firebase-admin` are different from `firebase/firestore`. Don't forget to
 * double check that you update the comments in `functions` as well.
 * =============================================================================
 */

import type {AssignmentId} from 'assignments/types';
import {
  doc,
  type DocumentReference,
  type FirestoreDataConverter,
  type QueryDocumentSnapshot,
} from 'firebase/firestore';
import {firestore} from 'firebaseApp';
import type {ProjectId} from 'projects/types';
import type {CourseId, UserId} from 'types/common';

/** ============== COPY EVERYTHING STARTING HERE TO functions ============= */

/**
 * A map of assignment IDs to project IDs for a given user in a given course.
 */
export interface UserAssignmentMap {
  [assignmentId: AssignmentId]: ProjectId;
}

const userAssignmentMapConverter: FirestoreDataConverter<UserAssignmentMap> = {
  toFirestore: (userAssignmentMap: UserAssignmentMap) => userAssignmentMap,
  fromFirestore: (snapshot: QueryDocumentSnapshot) =>
    snapshot.data() as UserAssignmentMap,
};

export const getUserAssignmentMapDocumentRef = ({
  userId,
  courseId,
}: {
  userId: UserId;
  courseId: CourseId;
}): DocumentReference<UserAssignmentMap> => {
  return doc(firestore, `users/${userId}/${courseId}/assnMap`).withConverter(
    userAssignmentMapConverter,
  );
};
